import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  PageHeader,
  message,
  Button,
} from "antd";
import R2Footer from "../../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MenuSetting from '../../../services/menuSetting';
import PaymentMethod from "./childrens/paymentMethod";
import CurrentPlan from "./childrens/currentPlan";
import "./style.scss";
import BillingHistory from "./childrens/billingHistory";
import SubscriptionService from "../../../services/subscriptionService";
import PriceWindow from "./childrens/priceWindow";

const { Content } = Layout;

const Subscription = (props) => {
  const defaultSetting = {
    "pos_bus_time_mins": 0,
    "pos_allow_bus_time": false,
    "pos_allow_cash_payment":false,
    "pos_allow_tipping_in_terminal":false,
    "pos_allow_tips_for_parties":false,
    "pos_tips_for_parties_greater_than":0,
    "pos_tips_for_parties_amount": 0
  };


  const [settingsList, setSettingsList ] = useState(defaultSetting);
  const [showPriceList, setShowPriceList] = useState(false);
  const [priceList, setPriceList] = useState([]);
  
  useEffect(()=>{
    MenuSetting.getRestaurentSettings(props.adminRestaurant).then((res)=>{
        if(res?.restaurant_id){
            setSettingsList(res);
        } else{
          setSettingsList(defaultSetting);
        }
    });
    SubscriptionService.getPriceTier().then((res)=>{
      if(res){
        setPriceList(res);
      }
    });
}, [props.adminRestaurant]);
const onUpdateValue = (e, field) => {
  const curentSettings = {...settingsList};
  curentSettings[field] = e;
  setSettingsList(curentSettings);
};
const isUpdateAllowValue = (e, field) => {
  const curentSettings = {...settingsList};
  curentSettings[field] = e.target.value;
  setSettingsList(curentSettings);
};
const showPriceTier = () => {
  setShowPriceList(true);
};

  return (
    <Layout className="u-page-layout pos-layout">
      <Content className="page-padding">
        <Space direction="vertical" style={{width: "100%" }}>
          <PageHeader title="Subscription" style={{ background: "#f0f2f5" }} />
          <div className="subscri-setup">
            <CurrentPlan showPriceTier={showPriceTier} />
            <PaymentMethod onUpdateValue={onUpdateValue} settingsList={settingsList} isUpdateAllowValue={isUpdateAllowValue} />
            <BillingHistory onUpdateValue={onUpdateValue} settingsList={settingsList} isUpdateAllowValue={isUpdateAllowValue} />
            <PriceWindow showPriceList={showPriceList} setShowPriceList={setShowPriceList} priceList={priceList}/>
          </div>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(Subscription));
